export default "__VITE_ASSET__DxS4Q2VP__"